import { render } from "./TestCaseValidationResults.vue?vue&type=template&id=10b1f53f"
import script from "./TestCaseValidationResults.vue?vue&type=script&lang=js"
export * from "./TestCaseValidationResults.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__